// extracted by mini-css-extract-plugin
export default {"categoryTitle":"CategoriesPage_categoryTitle__4jLx1","categoryList":"CategoriesPage_categoryList__jIdcY"};